export const OBTENER_PLATAFORMAS = 'OBTENER_PLATAFORMAS';
export const AGREGAR_PLATAFORMA = 'AGREGAR_PLATAFORMA';
export const ACTUALIZAR_PLATAFORMA = 'ACTUALIZAR_PLATAFORMA';
export const ELIMINAR_PLATAFORMA = 'ELIMINAR_PLATAFORMA';
export const PLATAFORMA_ERROR = 'PLATAFORMA_ERROR';
export const OBTENER_PLATAFORMA_STATS = 'OBTENER_PLATAFORMA_STATS';
